import {IntermediatePart} from "../../intermediatePart";

export default class Stovetop extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'stovetop';
    this.partName = 'Stovetop';
    this.translateId = "visualizer.kitchen.center_island.center_island_stovetop";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Stovetop());
  }

  disabledClick() {
    const applianceParent = this.getParent();
  //   if (!this.disabled) {
  //     // centerIslandParent.cabinet.disabled = false;
  //     // centerIslandParent.cabinet.disabledClick();
  //   } else {
  //     if (applianceParent.hood) {
  //       applianceParent.hood.disabled = this.disabled;
  //     }
  //   }
    if ((applianceParent.layout.type === 6) && !this.disabled && applianceParent.range
      && !applianceParent.range.disabled) {
      applianceParent.range.disabled = true;
    }
  }

}
